import { render } from "./Cadastro.vue?vue&type=template&id=23d3de4c&scoped=true"
import script from "./Cadastro.vue?vue&type=script&lang=js"
export * from "./Cadastro.vue?vue&type=script&lang=js"

import "./Cadastro.vue?vue&type=style&index=0&id=23d3de4c&lang=css"
import "./Cadastro.vue?vue&type=style&index=1&id=23d3de4c&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d3de4c"]])

export default __exports__